import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-49" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-50" data-mp="1ccdnwo55bito">
        <SectionHeading id="faq-title" data-id="element-51" data-mp="2a2icelvuq6qz">Frequently Asked <span className="text-teal-700" data-id="element-52" data-mp="2a05x6ghhaahm">Questions</span></SectionHeading>
        <div className="mt-10 divide-y divide-slate-200 border-y border-slate-200" data-id="element-53" data-mp="254gsjyqlq3eg">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} data-id="element-54" data-mp="1v3y4ssvx22r9" data-mpi={index}>
                <h3 className="font-sans" data-id="element-55" data-mp="1v72h6djjc4t0">
                  <button type="button" className="flex w-full items-center justify-between gap-5 rounded-md px-1 py-5 text-left font-semibold text-slate-900 transition-colors duration-150 ease-out hover:text-teal-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-teal-500/40" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-56" data-mp="op5tj1999u6f">
                    <span data-id="element-57" data-mp="1apssiozjtb76">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-58" data-mp="1ap0yvjpihnjj" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-59" data-mp="11v5u4csaxz4f">
                  {isOpen && <motion.div className="overflow-hidden" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-60" data-mp="16oqugbhdb56s">
                      <p className="px-1 pb-5 leading-relaxed text-slate-600" data-id="element-61" data-mp="mzggp316mubb">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}